// extracted by mini-css-extract-plugin
export default {"product":"MmlsP","productImage":"QLkcL","productContent":"Z8qjQ"};